import React from 'react';
import { FiZap, FiCircle, FiGrid } from 'react-icons/fi';

const products = [
  {
    icon: <FiZap />,
    title: 'Air Insulated Switchgear',
    description: 'Switchgear medium voltage dengan isolasi udara yang handal dan efisien untuk berbagai aplikasi industri dan komersial.',
    link: '#ais'
  },
  {
    icon: <FiZap />,
    title: 'Gas Insulated Switchgear',
    description: 'Switchgear dengan teknologi isolasi gas SF6 yang compact, aman, dan ideal untuk area dengan keterbatasan ruang.',
    link: '#gis'
  },
  {
    icon: <FiZap />,
    title: 'Metal Clad',
    description: 'Switchgear metal-clad dengan konstruksi kokoh dan keamanan tinggi untuk aplikasi distribusi daya medium voltage.',
    link: '#metal-clad'
  }
];

const Services = () => {
  return (
    <section className="services section" id="products">
      <div className="container">
        <div className="services-header">
          <span className="section-subtitle">Our Products</span>
          <h2 className="section-title">Medium Voltage Switchgear</h2>
          <p className="section-description">
            Kami menyediakan berbagai jenis switchgear medium voltage berkualitas tinggi
            yang memenuhi standar internasional untuk kebutuhan industri Anda.
          </p>
        </div>

        <div className="services-grid products-grid">
          {products.map((product, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">
                {product.icon}
              </div>
              <h3>{product.title}</h3>
              <p>{product.description}</p>
              <a href={product.link} className="learn-more">Learn More →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
